export function bindMatomoClicks(configs) {
    configs.forEach(({ selector, category, action, label }) => {
        document.querySelectorAll(selector).forEach((el) => {
            if (el.dataset.matomoBound === 'true') return;

            el.addEventListener('click', () => {
                window._paq = window._paq || [];
                window._paq.push(['trackEvent', category, action, label]);
            });

            el.dataset.matomoBound = 'true';
        });
    });
}

export function bindMatomoKeywordClicks(configs) {
    configs.forEach(({ selector, category, action, attribute = 'matomoKeyword' }) => {
        document.querySelectorAll(selector).forEach((el) => {
            if (el.dataset.matomoKeywordBound === 'true') return;

            el.addEventListener('click', () => {
                const keyword = (el.dataset[attribute] || el.textContent || '').trim();
                if (!keyword) return;

                window._paq = window._paq || [];
                window._paq.push(['trackEvent', category, action, keyword]);
            });

            el.dataset.matomoKeywordBound = 'true';
        });
    });
}